export default {
	create: {
		successMessage: 'New accordion key has been created.',
		error: {
			required: 'Field is required',
			maxLengthName: 'Name must not exceed {length} letters.',
			duplicateName: 'Duplicate attribute key name: {name}',
		},
	},
	delete: {
		successMessage: 'Remove accordion key success',
	},
};
